<template>
  <div>
    <portal to="sidebar-menu">
      <div class="pb-4">
        <nav-back-button to="/ecommerce/invoices">
          {{$t('invoice.menu.backToInvoices')}}
        </nav-back-button>

        <client-card :client="invoice.client" v-if="invoice.client"/>
        <nav-list class="mt-4" :items="navigationItems"/>

      </div>
    </portal>
    <router-view />
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import invoiceModule from '@/store/modules/invoice'
  import InvoiceService from 'src/services/InvoiceService'
  import ClientCard from 'src/components/Cards/ClientCard'
  import invoiceStatuses from 'src/config/invoiceStatuses'

  export default {
    name: 'invoice-edit',
    components: {
      ClientCard
    },
    data () {
      return {
        invoiceStatuses,
        loading: false
      }
    },
    computed: {
      ...mapState({
        invoice: state => state.invoice.currentInvoice || {},
      }),
      navigationItems() {
        return [
          {
            name: this.$t('generic.settings'),
            type: 'group'
          },
          {
            routeName: 'invoice_third_parties',
            name: this.$t('client.management.menu.thirdParties'),
          },
        ]
      }
    },
    methods: {
      ...mapMutations('invoice', [invoiceModule.types.SET_CURRENT_INVOICE]),
      async getData() {
        let { data } = await InvoiceService.getById(id, {
          with: 'client,invoiceLines'
        })
        this[invoiceModule.types.SET_CURRENT_INVOICE](data)
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await InvoiceService.getById(id, {
          with: 'client,invoiceLines'
        })
        if (res.data) {
          next(vm => {
            vm[invoiceModule.types.SET_CURRENT_INVOICE](res.data)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    },
  }
</script>
<style>
</style>
